import '../styles/LandingWhatMontreauxIs.css';
import React from 'react';

const ARROW_PATH = 'M1 6 H20 M15 1.5 L20 6 L15 10.5';

function LandingWhatMontreauxIs() {
  return (
    <section className="lwmi-section" aria-labelledby="lwmi-title">
      <div className="lwmi-rail" data-content-rail="primary">
        <svg
          className="lwmi-arc"
          viewBox="0 0 1200 40"
          preserveAspectRatio="none"
          aria-hidden="true"
          focusable="false"
        >
          <path
            d="M0 34 C 180 4, 380 2, 600 14 S 1020 38, 1200 10"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            vectorEffect="non-scaling-stroke"
          />
        </svg>

        <div className="lwmi-panel">
          <p className="lwmi-eyebrow">What Montreaux is</p>
          <h2 id="lwmi-title" className="lwmi-statement">
            Montreaux is a simple loan service for everyday applicants. The
            loan information on the Loans page explains the offering clearly —
            read it, then send an application when you are ready.
          </h2>
          <a className="lwmi-link" href="/loans">
            <span>Read the loan information</span>
            <svg viewBox="0 0 21 12" aria-hidden="true" focusable="false">
              <path
                d={ARROW_PATH}
                fill="none"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </a>
        </div>

        <div className="lwmi-flourish" aria-hidden="true">
          <svg viewBox="0 0 360 220" preserveAspectRatio="xMidYMid meet" focusable="false">
            <path
              d="M10 200 C 110 200, 120 20, 230 24 S 330 120, 350 40"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeDasharray="1 9"
            />
            <circle cx="230" cy="24" r="46" fill="none" stroke="#1F4E4A" strokeWidth="1.5" opacity="0.6" />
            <circle cx="230" cy="24" r="6" fill="#D9502E" />
          </svg>
        </div>
      </div>
    </section>
  );
}

export default LandingWhatMontreauxIs;